import { Icon, IconProps } from '@chakra-ui/react';
import { FC } from 'react';

export const IndigoLogoGradient: FC<IconProps> = (props) => {
  return (
    <Icon
      fill="none"
      height="14px"
      viewBox="0 0 14 14"
      width="14px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="7.18359"
        cy="2.18359"
        fill="url(#paint0_linear_12328_35477)"
        r="2"
      />
      <circle
        cx="7.18359"
        cy="11.8164"
        fill="url(#paint1_linear_12328_35477)"
        r="2"
      />
      <circle cx="12" cy="7" fill="url(#paint2_linear_12328_35477)" r="2" />
      <circle
        cx="2.36719"
        cy="7"
        fill="url(#paint3_linear_12328_35477)"
        r="2"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_12328_35477"
          x1="9.18359"
          x2="5.0322"
          y1="0.9483"
          y2="3.74729"
        >
          <stop stopColor="#B973FF" />
          <stop offset="1" stopColor="#6E67D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_12328_35477"
          x1="9.18359"
          x2="5.0322"
          y1="10.5811"
          y2="13.3801"
        >
          <stop stopColor="#B973FF" />
          <stop offset="1" stopColor="#6E67D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_12328_35477"
          x1="14"
          x2="9.84861"
          y1="5.76471"
          y2="8.56369"
        >
          <stop stopColor="#B973FF" />
          <stop offset="1" stopColor="#6E67D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_12328_35477"
          x1="4.36719"
          x2="0.215794"
          y1="5.76471"
          y2="8.56369"
        >
          <stop stopColor="#B973FF" />
          <stop offset="1" stopColor="#6E67D6" />
        </linearGradient>
      </defs>
    </Icon>
  );
};
